import { InviewAnim } from "../utils/animations"

export const AboutComponent = () => {
    return (
        <div className="about-container">
            <InviewAnim inView={'slide-up-after'} notInView={'slide-up-before'}>
                <div className="about-unit">
                    <img src="/svgs/express-delivery.svg" alt="" className="about-image" />
                    <div className="about-caption">LIVRAISON RAPIDE</div>
                    <p className="about-info">
                        Nous livrons sous 3 heures à Douala, et sous 24 heures dans les autres villes.
                    </p>
                </div>
            </InviewAnim>
            
            <InviewAnim inView={'slide-up-after'} notInView={'slide-up-before'}>
                <div className="about-unit">
                    <img src="/svgs/delivery.svg" alt="" className="about-image" />
                    <div className="about-caption">PAIEMENT À LA LIVRAISON</div>
                    <p className="about-info">
                        Le paiement s'effectue à la livraison, en espèces, par mobile money ou par orange money.
                    </p>
                </div>
            </InviewAnim>

            <InviewAnim inView={'slide-up-after'} notInView={'slide-up-before'}>
                <div className="about-unit">
                    <img src="/svgs/package-return.svg" alt="" className="about-image" />
                    <div className="about-caption">RETOUR FACILE ET RAPIDE</div>
                    <p className="about-info">
                        Nous acceptons les retours de marchandises dans les sept jours suivant la livraison.
                    </p>
                </div>
            </InviewAnim>

            <InviewAnim inView={'slide-up-after'} notInView={'slide-up-before'}>
                <div className="about-unit">
                    <img src="/svgs/customer-service.svg" alt="" className="about-image" />
                    <div className="about-caption">SERVICE CLIENTÈLE ​​24H/24 ET 7J/7</div>
                    <p className="about-info">
                       Nous sommes toujours disponibles pour aider nos clients, prendre en compte leurs préoccupations et répondre à leurs questions.
                    </p>
                </div>
            </InviewAnim>
        </div>
    )
}